import React, { useEffect } from 'react';
import { Image, View, StyleSheet, TouchableOpacity } from 'react-native';
import CustomActivityIndicator from '../../components/CustomActivityIndicator/CustomActivityIndicator';
import Ionicons from "@react-native-vector-icons/ionicons/static";
import { createMaterialTopTabNavigator } from '@react-navigation/material-top-tabs';
import Home from '../../screens/Home';
import HRAdmin from '../../screens/HRAdmin';
import Recruitment from '../../screens/Recruitment';
import Shifts from '../../screens/Shifts';
import MyAccountScreen from '../../screens/SelfService/MyAccount/MyAccountScreen';
import SettingsScreen from '../../screens/Settings/SettingsScreen';
import AccountDropdown from '../../components/CustomDropDown/AccountDropDown';
import { HeaderBackButton } from '@react-navigation/elements';
import { useColorScheme } from 'react-native';
import { useAccountContext } from '../../hooks/useAccountContext';
import { useSettings } from '../../hooks/useSettings'
import useRole from '../../hooks/userRole';

const Tab = createMaterialTopTabNavigator();

const TabNavigationWeb = () => {
    const { companyDetails } = useAccountContext();
    const { isHR, isAdmin } = useRole();
    const { getSettings, getEmployeeTabs, getTrainingTabs, isLoading } = useSettings();
    let colorScheme = useColorScheme();
    colorScheme = 'light';

    // * Refresh settings only on page refresh because this is not changin often. 
    // * The all the settings are set in states in useSetting and could be fetched in there 
    useEffect(() => {
        getSettings().then(() =>
            getEmployeeTabs().then(() =>
                getTrainingTabs().catch(console.error)
            ).catch(console.error)
        ).catch(console.error)
    }, [])

    const CustomTopTabBarWeb = ({ state, descriptors, navigation }) => {
        if (!state) {
            console.log('Navigation state not ready');
            return null; // Or a loading fallback
        }

        return (
            <View style={{ height: 45, undefined, backgroundColor: '#FFFFFF', borderBottomWidth: 1, borderColor: '#86BC25', flexDirection: 'row', alignItems: 'center', justifyContent: 'flex-end', zIndex: 999 }}>
                <View style={{ flex: 1 }}>
                    {companyDetails?.logo && (
                        <Image
                            source={{ uri: 'data:image/jpeg;base64,' + companyDetails?.logo }}
                            resizeMode="contain"
                            style={{ width: 125, height: 43, margin: 5 }}
                        />
                    )}

                </View>
                {Array.isArray(state?.routes) &&
                    state.routes
                        .filter(route => ['home', 'HRAdmin', 'Recruitment', 'Shifts'].includes(route.name))
                        .map((route, index) => {
                            const { options } = descriptors[route.key];
                            const label =
                                options.tabBarLabel !== undefined
                                    ? options.tabBarLabel
                                    : route.name;

                            const isFocused = state?.index === index;

                            const onPress = () => {
                                if (!isFocused) {
                                    navigation.navigate(route.name);
                                }
                            };

                            let iconName;

                            switch (route.name) {
                                case 'home':
                                    iconName = 'home-outline';
                                    break;
                                case 'HRAdmin':
                                    iconName = 'people-outline';
                                    break;
                                case 'Recruitment':
                                    iconName = 'briefcase-outline';
                                    break;
                                case 'Shifts':
                                    iconName = 'time-outline';
                                    break;
                                default:
                                    break;
                            }

                            return (
                                <TouchableOpacity
                                    key={route.key}
                                    onPress={onPress}
                                >
                                    <Ionicons
                                        name={iconName}
                                        size={24}
                                        color={isFocused ? '#86BC25' : '#ccc'}
                                        style={{ marginHorizontal: 3 }}
                                    />
                                    {/* <Text style={{ color: isFocused ? 'dodgerblue' : 'gray', fontSize: 12 }}></Text> */}
                                </TouchableOpacity>

                            );
                        })}
                <AccountDropdown />
            </View>
        );
    }

    if (isLoading) {
        return (
            <CustomActivityIndicator />
        )
    }
    return (
        <>
            <Tab.Navigator
                screenOptions={() => ({
                    swipeEnabled: false, //! disable swiping for now, since only one tab
                })}
                tabBar={(props) => <CustomTopTabBarWeb {...props} />
                }>
                <Tab.Screen name="home" component={Home} />
                {(isHR || isAdmin) && <Tab.Screen name="HRAdmin" component={HRAdmin} />}
                {/* //* under dev so remove hasAccess('Candidate', false, 'HR') ||  */}
                {(isAdmin) && <Tab.Screen name="Recruitment" component={Recruitment} />}
                {(isAdmin) && <Tab.Screen name="Shifts" component={Shifts} />}
                <Tab.Screen name="MyAccountScreen" component={MyAccountScreen} />
                <Tab.Screen name="SettingsScreen" component={SettingsScreen}
                    options={({ navigation }) => ({
                        tabBarLabel: 'HR Admin',
                        headerLeft: (props) => (
                            <HeaderBackButton {...props} onPress={() => {
                                // Custom back behavior, e.g., navigate to a specific screen 
                                navigation.navigate('home');
                            }} />),
                    })}
                />
            </Tab.Navigator>
        </>
    );
}

const styles = StyleSheet.create({
    label: {
        fontSize: 10,
        marginBottom: '3%',
        fontFamily: 'Roboto-Medium',
    },
});
export default TabNavigationWeb;